import {useState} from 'react'
import {usePullRequestArtifacts} from './use-pull-request-artifacts'

export const useSelectedPullRequestArtifact = () => {
  const {data, isPending, isLoadingError} = usePullRequestArtifacts()
  const artifacts = data?.artifacts ?? []

  const [selectedNumber, setSelectedNumber] = useState<number | null>(null)
  const selectedArtifact =
    selectedNumber === null ? artifacts[0] : artifacts.find(artifact => artifact.number === selectedNumber)

  return {artifacts, isPending, isLoadingError, selectedArtifact, setSelectedNumber}
}
